(function () {
  if (window.ZeirAboutTabsLoaded) return;
  window.ZeirAboutTabsLoaded = true;

  function activateTab(root, index) {
    var tabs = root.querySelectorAll('[data-about-tab]');
    var tabItems = root.querySelectorAll('[data-about-tab-item]');
    var panels = root.querySelectorAll('.about-tab__panel');
    var mediaPanels = root.querySelectorAll('[data-about-panel]');

    tabs.forEach(function (tab, tabIndex) {
      var isActive = tabIndex === index;
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    });

    tabItems.forEach(function (item, itemIndex) {
      item.classList.toggle('is-active', itemIndex === index);
    });

    panels.forEach(function (panel, panelIndex) {
      panel.hidden = panelIndex !== index;
    });

    mediaPanels.forEach(function (panel, panelIndex) {
      panel.hidden = panelIndex !== index;
      panel.classList.toggle('is-active', panelIndex === index);
    });
  }

  function initAboutTabs(scope) {
    var roots = scope.matches && scope.matches('[data-about-tabs-root]')
      ? [scope]
      : scope.querySelectorAll('[data-about-tabs-root]');

    roots.forEach(function (root) {
      if (root.dataset.aboutTabsInitialized === 'true') return;

      root.addEventListener('click', function (event) {
        var tab = event.target.closest('[data-about-tab]');
        if (!tab || !root.contains(tab)) return;

        activateTab(root, Number(tab.dataset.aboutTab));
      });

      root.dataset.aboutTabsInitialized = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAboutTabs(document);
    });
  } else {
    initAboutTabs(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAboutTabs(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest('[data-about-tabs-root]');
    var tabItem = event.target.closest('[data-about-tab-item]');
    var tabs;

    if (!root || !tabItem) return;

    tabs = Array.prototype.slice.call(root.querySelectorAll('[data-about-tab-item]'));
    activateTab(root, tabs.indexOf(tabItem));
  });
})();
